import styled from 'styled-components'

export default styled('div')`
  font-size: 2em;
  font-weight: 500;
  margin-bottom: 10px;
`
